var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTitleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 28.7333V9.33333H9.33333V4H23.4V14.6667H28.7333V28.7333H17.7V23.0333H15.0333V28.7333H4ZM7.03333 25.7H9.7V23.0333H7.03333V25.7ZM7.03333 20.3667H9.7V17.7H7.03333V20.3667ZM7.03333 15.0333H9.7V12.3667H7.03333V15.0333ZM12.3667 20.3667H15.0333V17.7H12.3667V20.3667ZM12.3667 15.0333H15.0333V12.3667H12.3667V15.0333ZM12.3667 9.7H15.0333V7.03333H12.3667V9.7ZM17.7 20.3667H20.3667V17.7H17.7V20.3667ZM17.7 15.0333H20.3667V12.3667H17.7V15.0333ZM17.7 9.7H20.3667V7.03333H17.7V9.7ZM23.0333 25.7H25.7V23.0333H23.0333V25.7ZM23.0333 20.3667H25.7V17.7H23.0333V20.3667Z",
    fill: "url(#paint0_linear_933_8540)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_933_8540",
    x1: 4,
    y1: 4,
    x2: 28.7333,
    y2: 28.7333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.224762,
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852864,
    stopColor: "#1D5AE8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleIcon);
export default __webpack_public_path__ + "static/media/TitleIcon.e9b48f5f61b736a4f4159daeec272972.svg";
export { ForwardRef as ReactComponent };